import { render, staticRenderFns } from "./TransferGraduationSendDocumentForm.vue?vue&type=template&id=2cfaf83a&scoped=true&"
import script from "./TransferGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationSendDocumentForm.vue?vue&type=style&index=0&id=2cfaf83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaf83a",
  null
  
)

export default component.exports